export enum FaceGateStripMode {
  Indexing = 'indexing',
  PeopleModels = 'people-models'
}
